export default {
  title: 'HubRise',
  setup: {
    description: 'Partajați date cu alte aplicații.',
  },
  form: {
    is_menus_sync_enabled: 'Sincronizați meniul',
    is_inventory_sync_enabled: 'Sincronizați inventarul',
    is_opening_hours_sync_enabled: 'Sincronizați programul de funcționare',
    is_order_acceptance_mode_sync_enabled: 'Sincronizați starea ocupat / pauză',
    variant_ref: 'Variantă de meniu',
    variant_ref_default: 'Implicit',
  },
  tabs: {
    settings: 'Setări',
    service_types: 'Tipuri de servicii',
    payments: 'Plăți',
    charges: 'Taxe',
    deals: 'Oferte',
    discounts: 'Reduceri',
    customers: 'Clienți',
  },
  customers: {
    description:
      'Ștergeți datele unui client pe partea HubRise, de exemplu după o solicitare de ștergere a datelor. Această acțiune nu poate fi anulată.',
    customer: 'Client',
    placeholder: 'Căutați după nume, e-mail sau telefon…',
  },
  mapping: {
    description:
      'Asociați fiecare entitate {{provider}} cu valoarea și numele HubRise corespunzătoare. Lăsați un rând gol pentru a utiliza valorile implicite {{provider}}.',
    entity: '{{provider}}',
    value: 'Valoare HubRise',
    name: 'Nume HubRise',
  },
  connecting: {
    title: 'Se finalizează conexiunea HubRise…',
    description: 'Durează câteva secunde. Vă rugăm să păstrați această pagină deschisă.',
    error_title: 'Conexiunea HubRise durează mai mult decât era prevăzut',
    error_description:
      'HubRise a fost autorizat, dar conexiunea nu a fost confirmată încă. Verificați din nou în câteva momente — dacă problema persistă, porniți din nou conexiunea.',
  },
  buttons: {
    connect: 'Conectați la HubRise',
    check_again: 'Verificați din nou',
    disconnect: 'Deconectați',
    go_to_hubrise: 'Mergeți la HubRise',
    pull_menus: 'Preluați meniul',
    pull_inventory: 'Preluați inventarul',
    save: 'Salvați',
    delete_customer: 'Ștergeți clientul',
  },
  toasts: {
    connected: 'HubRise a fost conectat',
    connect_cancelled: 'Conexiunea HubRise a fost anulată',
    connect_error: 'Pornirea conexiunii HubRise a eșuat',
    connect_timeout: 'Conexiunea HubRise nu a putut fi confirmată încă',
    local_changes_replaced:
      'Setările HubRise au fost actualizate în altă parte — modificările nesalvate au fost înlocuite',
    disconnect_success: 'HubRise a fost deconectat',
    disconnect_error: 'Deconectarea HubRise a eșuat',
    pull_menus_success: 'Sincronizarea meniului a fost pornită',
    pull_menus_error: 'Preluarea meniului a eșuat',
    pull_inventory_success: 'Sincronizarea inventarului a fost pornită',
    pull_inventory_error: 'Preluarea inventarului a eșuat',
    save_success: 'Setările HubRise au fost salvate',
    save_error: 'Salvarea setărilor HubRise a eșuat',
    load_customers_error: 'Încărcarea clienților a eșuat',
    delete_customer_success: 'Ștergerea datelor clientului a fost solicitată',
    delete_customer_error: 'Ștergerea datelor clientului a eșuat',
  },
  delete_customer_confirm: {
    title: 'Ștergeți acest client din HubRise?',
    description: 'Datele clientului vor fi șterse pe partea HubRise. Această acțiune nu poate fi anulată.',
    ok: 'Ștergeți',
    cancel: 'Anulați',
  },
  disconnect_confirm: {
    title: 'Deconectați HubRise?',
    description: 'Aceasta va opri sincronizarea meniurilor, stocului și comenzilor cu HubRise.',
    ok: 'Deconectați',
    cancel: 'Anulați',
  },
  connected: {
    title: 'Conectat la HubRise',
    description: 'Contul dvs. HubRise a fost conectat cu succes.',
    account: 'Cont',
    location: 'Locație',
    catalog: 'Catalog',
    customer_list: 'Listă clienți',
  },
};
